import { render, staticRenderFns } from "./resize.vue?vue&type=template&id=25342120&"
import script from "./resize.vue?vue&type=script&lang=js&"
export * from "./resize.vue?vue&type=script&lang=js&"
import style0 from "./resize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports